import { useState } from "react";

import { ScrollMenu } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";

import BarLoader from "react-spinners/BarLoader";

import { PiSoccerBall } from "react-icons/pi";
import {
  IoAmericanFootball,
  IoAmericanFootballOutline,
  IoBasketballOutline,
} from "react-icons/io5";
import { IoBaseball } from "react-icons/io5";
import { FaHockeyPuck } from "react-icons/fa";
import { FaFlagCheckered } from "react-icons/fa";
import { IoBasketball } from "react-icons/io5";
import { RiBoxingFill } from "react-icons/ri";

import { useTranslation } from "react-i18next";

function AboutUsPage() {
  const { t } = useTranslation("common");

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const leagues = [
    {
      name: "LIGA MAYOR DE FUTBOL SALVADOREÑO",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FLigaMayordeFutbolSalvadoren%CC%83o.png?alt=media&token=80f32a29-7339-4fb3-bd3f-45cd6118d6a2",
    },
    {
      name: "SPANISH LALIGA",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FLaliga.png?alt=media&token=9f3a0aa8-4bd6-48ef-9103-44516b7f9235",
    },
    {
      name: "BRITISH PREMIER LEAGUE",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FPremier%20League.png?alt=media&token=2275034e-50ad-4194-a893-e931f4c2d91b",
    },
    {
      name: "MAJOR LEAGUE SOCCER (MLS)",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FMLS.png?alt=media&token=b63ae020-a1fc-4561-8497-c9f988826769",
    },
    {
      name: "GERMAN BUNDESLIGA",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FBundesliga.png?alt=media&token=5b9012e6-bf6e-4e42-87e1-2e81ecf975f5",
    },
    {
      name: "ITALIAN SERIE A",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FSerieA.png?alt=media&token=b6eddcf3-0de4-4c7c-9cde-4325b850b028",
    },
    {
      name: "FRENCH LIGUE 1",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FLigue%201.png?alt=media&token=f4f5e522-19f8-4df0-a059-72b42c83f2e9",
    },
    {
      name: "MEXICAN LIGA MX",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FLigaMX.png?alt=media&token=f20ad948-f9d8-4145-9cd8-3974770a7abe",
    },
    {
      name: "PRIMERA DIVISIÓN DE ARGENTINA",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FPrimeraDivision.png?alt=media&token=78ded3da-9d2d-4fa1-ad7d-ee4b82a60281",
    },
    {
      name: "FIFA WORLD CUP",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FFifaWorldCup.png?alt=media&token=b4424420-d76c-4cc5-9121-3d68cbe56f60",
    },
    {
      name: "UEFA CHAMPIONS LEAGUE",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FUEFA.png?alt=media&token=f3ec96fa-c83d-4b7d-86b8-4f8ba0a8ec32",
    },
    // { "name": "UEFA NATIONS LEAGUE", "image": "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FUEFA.png?alt=media&token=f3ec96fa-c83d-4b7d-86b8-4f8ba0a8ec32" },
    {
      name: "UEFA EUROPA LEAGUE",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FUEFA.png?alt=media&token=f3ec96fa-c83d-4b7d-86b8-4f8ba0a8ec32",
    },
    {
      name: "UEFA EUROPEAN CHAMPIONSHIP",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FUEFA.png?alt=media&token=f3ec96fa-c83d-4b7d-86b8-4f8ba0a8ec32",
    },
    // { "name": "UEFA WORLD CUP QUALIFYING", "image": "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FUEFA.png?alt=media&token=f3ec96fa-c83d-4b7d-86b8-4f8ba0a8ec32" },
    {
      name: "GOLD CUP",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FConcacaf.png?alt=media&token=c316c969-f67b-4ce1-9aa6-b80efb2a51c4",
    },
    // { "name": "CONCACAF WORLD CUP QUALIFYING", "image": "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FConcacaf.png?alt=media&token=c316c969-f67b-4ce1-9aa6-b80efb2a51c4" },
    {
      name: "CONCACAF LEAGUES CUP",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FConcacaf.png?alt=media&token=c316c969-f67b-4ce1-9aa6-b80efb2a51c4",
    },
    {
      name: "COPA AMERICA",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FCopaAmerica.png?alt=media&token=1c395621-009e-431d-a6dc-5621e02e41ed",
    },
    // { "name": "CONMEBOL WORLD CUP QUALIFYING", "image": "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FCONMEBOL.png?alt=media&token=579fb2d8-3efe-418f-870f-140855f8cf34" },
    {
      name: "CONMEBOL COPA LIBERTADORES",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FCONMEBOL.png?alt=media&token=579fb2d8-3efe-418f-870f-140855f8cf34",
    },
    {
      name: "NFL",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FNFL.png?alt=media&token=809de808-8405-4566-a350-d669689fb77c",
    },
    {
      name: "NBA",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FNBA.png?alt=media&token=87f58d83-9033-4a7a-ba80-6b2603d7ab60",
    },
    {
      name: "MLB",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FMLB.png?alt=media&token=da8dca12-74bb-44ea-aaea-7db50476d14b",
    },
    {
      name: "NHL",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FNHL.png?alt=media&token=57fe8bf3-c3d7-4996-b5e6-da16c1e6438c",
    },
    {
      name: "UFC",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FUFC.png?alt=media&token=c9fd7080-ea41-4f2b-8b88-0dfb796ab037",
    },
    {
      name: "FORMULA 1 WORLD GRAND PRIX",
      image:
        "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2FleaguesNew%2FF1.png?alt=media&token=e44b7b48-e31a-46b9-b8d4-37d11d556446",
    },
  ];

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="aboutUsPage" className="page">
      <div className="aboutUsSection">
        {/* <div className='aboutUsBanner'>

        </div> */}
        <img
          className="aboutUsBanner"
          alt="AboutUsAboutUsBanner"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FAbout%20Us%2FAboutPageAboutUs.png?alt=media&token=d615446e-86db-4945-b386-3096541d77d5"
        />
        <h1>{t("aboutUs").toUpperCase()}</h1>
        <p>
          {t("aboutUsText1")}
          {/* Which sport is you're favorite? Here, you'll have the freedom to choose! Pick your favorite team and place your predictions. If you get it right, you'll accumulate points that will enable you to win various prizes.<br/>
          Whether you're a football, basketball, baseball enthusiast, or any other sport, our platform is designed for all fans to find the fun and excitement they're seeking. Are you ready to demonstrate your prowess as a predictor and win great prizes? Join us now and become part of our passionate online sports community! */}
        </p>
      </div>
      <div className="aboutUsSection">
        {/* <div className='aboutUsBanner'>

        </div> */}
        <img
          className="aboutUsBanner"
          alt="AboutUsOurGoalBanner"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FAbout%20Us%2FAboutPageOurGoal.png?alt=media&token=2eacd269-9ebf-4335-b58d-7dd9024bb7af"
        />
        <h1>
          {t("ourGoal").toUpperCase()}
          <span style={{ fontSize: 16 }}>
            {" "}
            {t("punIntended").toUpperCase()}
          </span>
        </h1>
        <p>{t("ourGoalText")}</p>
      </div>
      <div className="aboutUsSection">
        <h1>{t("ourSports").toUpperCase()}</h1>
        <p>{t("ourSportsText")}</p>
        <ScrollMenu>
          <div className="aboutUsSportContainer">
            <PiSoccerBall />
            <p>PRO SOCCER</p>
          </div>
          <div className="aboutUsSportContainer">
            <IoAmericanFootball />
            <p>PRO AMERICAN FOOTBALL</p>
          </div>
          <div className="aboutUsSportContainer">
            <IoBaseball />
            <p>PRO BASEBALL</p>
          </div>
          <div className="aboutUsSportContainer">
            <FaHockeyPuck />
            <p>PRO HOCKEY</p>
          </div>
          <div className="aboutUsSportContainer">
            <FaFlagCheckered />
            <p>PRO RACING</p>
          </div>
          <div className="aboutUsSportContainer">
            <IoBasketball />
            <p>PRO BASKETBALL</p>
          </div>
          <div className="aboutUsSportContainer">
            <RiBoxingFill />
            <p>MMA</p>
          </div>
          <div className="aboutUsSportContainer">
            <IoAmericanFootballOutline />
            <p>COLLEGE FOOTBALL</p>
          </div>
          <div className="aboutUsSportContainer">
            <IoBasketballOutline />
            <p>COLLEGE BASKETBALL</p>
          </div>
        </ScrollMenu>
      </div>
      <div>
        <h1>{t("ourLeagues").toUpperCase()}</h1>
        <p></p>
        <ScrollMenu>
          {leagues?.map((league) => {
            return (
              <div className="aboutUsLeagueContainer">
                <img
                  alt="leagueImage"
                  src={league.image}
                  style={{ marginBottom: "0.5rem" }}
                  // style={{marginTop: league.name === 'FORMULA 1 WORLD GRAND PRIX' ? 75 : 0, marginBottom: league.name === 'FORMULA 1 WORLD GRAND PRIX' ? 35 : 0}}
                />
                <p>{league.name}</p>
              </div>
            );
          })}
        </ScrollMenu>
      </div>
    </div>
  );
}

export default AboutUsPage;
